module.exports = __webpack_public_path__ + "img/ga_03.348d5129.png";